var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameHourglassMobile = function SvgIconStorygameHourglassMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 15.604-.007-4-2.66-2.666 2.66-2.674L12 2.271H4v4l2.667 2.667L4 11.598v4.006h8ZM5.333 5.938V3.604h5.334v2.334L8 8.604 5.333 5.938Z",
    fill: "url(#icon-storygame-hourglass-mobile_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-storygame-hourglass-mobile_svg__a",
    x1: 12,
    y1: 2.271,
    x2: 2.168,
    y2: 14.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753BBD"
  })))));
};
export default SvgIconStorygameHourglassMobile;